import { HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { forkJoin, Observable, of, throwError } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ToastService } from './toast.service';
import { AlertController, Platform } from '@ionic/angular/standalone';
import { from } from 'rxjs/internal/observable/from';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { UsersService } from './users.service';
import { AppHelper } from '../app.helper';
import { AppService } from './app.service';
import { Configuration } from '../configuration';
import { inject } from '@angular/core';
import { NetworkStatusService } from './network-status.service';

export class InterceptorService implements HttpInterceptor {
	private showingError = false;
	private usersService = inject(UsersService);
	private toastService = inject(ToastService);
	private router = inject(Router);
	private platform = inject(Platform);
	private alertCtrl = inject(AlertController);
	private _appService = inject(AppService);
	private networkStatusService = inject(NetworkStatusService);

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		let headers = {};
		let url = req.url;
		if (this.usersService.urlForce) {
			url = url.replace(Configuration.getString('wsApiUrl'), this.usersService.urlForce);
		}

		const noAuthHeader = req.url.includes('blob.core.windows.net');

		return of(true).pipe(
			// tap((data) => (data[0]) ? data[0].present() : true),
			map((data) => {
				if (
					!req.url.includes('Token') &&
					!req.url.includes('service.cgi') &&
					!req.url.includes('printer.htm') &&
					(req.url.includes(environment.wsApiUrl) || req.url.includes(environment.wsApiUrlSalonMenu))
				) {
					//TODO: TO CHECK MELVIN
					//if (!req.url.includes('Token') && !req.url.includes('service.cgi') && req.url.includes(Configuration.getString('wsApiUrl'))) {
					const LastAppVersion = environment.appVersion;
					const LastDeviceType = this.platform.platforms().join(', ');
					headers = {
						LastAppVersion,
						LastDeviceType,
					};

					if (this.usersService.selectedClient) {
						const client = this.usersService.selectedClient;
						headers['ClientCoreId'] = client.clientCoreId;
						headers['SalonId'] = client.salonId;
					}

					const access_token = this.usersService.getAccessToken();
					if (access_token) {
						if (!noAuthHeader) {
							headers['Authorization'] = 'Bearer ' + access_token;
						}
					}

					return req.clone({
						url,
						headers: new HttpHeaders(headers),
					});
				}

				return req;
			}),
			switchMap((reqN) =>
				next.handle(reqN).pipe(
					catchError((err) => {
						if (window.location.href.includes('contact-us'))
							return throwError(() => err);

						if (err instanceof HttpErrorResponse) {
							const errObj = err.error as HttpErrorResponse;
							if (errObj && (errObj['IsSuccess'] !== undefined || errObj['isSuccess'] !== undefined))
								return throwError(() => err);
						}

						// if (this.isBlockingPaymentDateError(err)) {
						// 	this.handleBlockingPaymentDateError(err);
						// 	return throwError(() => err);
						// }

						const keys = Object.keys(err);
						for (const key of keys) {
							// tslint:disable-next-line:no-console
							console.error('[ERROR ' + key + ']', err[key]);
						}

						if (!this.networkStatusService.getStatus() || err.status === 0) {
							this.toastService.showToast(
								'Errore di connessione. Controlla la tua connessione internet',
								'error'
							);
							return throwError(() => err);
						}

						const error = this.toastService.resolveError(err);

						if (err.status && (err.status === 401 || err.status === 403)) {

							const isVersionAppError = error === "ATTENZIONE!! L'app non è aggiornata all'ultima versione, si prega di aggiornare. In caso di problemi contattare il supporto tecnico.";
							const isBlockingPaymentError = error === 'ATTENZIONE: riscontrati problemi con l’account si prega di contattare il supporto tecnico';

							if (err.status === 403 && !this.showingError && isVersionAppError) {
								this.showingError = true;
								this.alertCtrl
									.create({
										header: 'Attenzione',
										message: error,
										buttons: [
											{
												text: 'Clicca per aggiornare',
												cssClass:
													'version-button default-button ion-text-capitalize ion-margin-horizontal box-shadow ion-margin-top md button button-block button-solid ion-activatable ion-focusable hydrated',
												handler: () => AppHelper.storeRedirectionHandler(this.platform),
											},
										],
									})
									.then((modal) => modal.present());
							} else if (err.status === 403 && !this.showingError && isBlockingPaymentError) {
							} else {
								this.usersService.logout();
							}
						} else if (err.status && err.status === 500 && url.includes('currentUserInfo')) {
							this.usersService.logout();
						} 

						return throwError(() => err);
					}),
				),
			),
		);
	}

	private isBlockingPaymentDateError(error: HttpErrorResponse) {
		if (error instanceof HttpErrorResponse) {
			return (
				error.status === 403 &&
				error.error === 'ATTENZIONE: riscontrati problemi con l’account si prega di contattare il supporto tecnico'
			);
		}

		return false;
	}

	private async handleBlockingPaymentDateError(error: HttpErrorResponse) {
		this._appService.setBlockingPaymentError(error.error);
		await this._appService.logOut(this.router);
	}
}
